import React from "react";

const SeoSettings = ({ seoData, setSeoData, t_controls, availableLocales = [] }) => {
  const handleChange = (field, locale, value) => {
    setSeoData({
      ...seoData,
      [field]: {
        ...seoData[field],
        [locale]: value
      }
    });
  };

  const handleSimpleChange = (field, value) => {
    setSeoData({
      ...seoData,
      [field]: value
    });
  };

  // Locale display names
  const localeLabels = {
    'en': 'English',
    'lt': 'Lietuvių',
    'ru': 'Русский',
    'de': 'Deutsch',
    'fr': 'Français',
    'es': 'Español',
    'pl': 'Polski',
    'uk': 'Українська'
  };

  // Build locales array from availableLocales prop
  const locales = availableLocales.map(code => ({
    code: code,
    label: localeLabels[code] || code.toUpperCase()
  }));

  return (
    <div className="card mt-3">
      <div className="card-body">
        <h5 className="card-title">{t_controls.seo_settings}</h5>
        <p className="text-muted">{t_controls.seo_multilang_note || "Configure SEO settings for each language"}</p>

        {/* Team Location Settings */}
        <div className="form-group mt-3">
          <label><strong>{t_controls.team_location || "Team Location"}</strong></label>
          <small className="form-text text-muted mb-2">
            {t_controls.team_location_help || "Location details used for SEO meta tags"}
          </small>

          <div className="mb-2">
            <label htmlFor="teamCity" className="small text-muted">{t_controls.team_city || "Team City"}</label>
            <input
              type="text"
              className="form-control"
              id="teamCity"
              value={seoData.team_city || ""}
              onChange={(e) => handleSimpleChange("team_city", e.target.value)}
              placeholder="e.g., New York"
            />
          </div>

          <div className="mb-2">
            <label htmlFor="teamCountry" className="small text-muted">{t_controls.team_country || "Team Country"}</label>
            <input
              type="text"
              className="form-control"
              id="teamCountry"
              value={seoData.team_country || ""}
              onChange={(e) => handleSimpleChange("team_country", e.target.value)}
              placeholder="e.g., United States"
            />
          </div>

          <div className="mb-2">
            <label htmlFor="teamLeague" className="small text-muted">{t_controls.team_league || "Team League"}</label>
            <input
              type="text"
              className="form-control"
              id="teamLeague"
              value={seoData.team_league || ""}
              onChange={(e) => handleSimpleChange("team_league", e.target.value)}
              placeholder="e.g., National Hockey League"
            />
          </div>
        </div>

        {/* SEO Site Name */}
        <div className="form-group mt-3">
          <label><strong>{t_controls.seo_site_name}</strong></label>
          <small className="form-text text-muted mb-2">
            {t_controls.seo_site_name_help || "The name of your site for SEO and social sharing"}
          </small>
          {locales.map(({ code, label }) => (
            <div key={`sitename-${code}`} className="mb-2">
              <label htmlFor={`seoSiteName-${code}`} className="small text-muted">{label}</label>
              <input
                type="text"
                className="form-control"
                id={`seoSiteName-${code}`}
                value={(seoData.site_name && seoData.site_name[code]) || ""}
                onChange={(e) => handleChange("site_name", code, e.target.value)}
                placeholder={`e.g., Team Name - Club Name (${label})`}
              />
            </div>
          ))}
        </div>

        {/* SEO Keywords */}
        <div className="form-group mt-4">
          <label><strong>{t_controls.seo_keywords}</strong></label>
          <small className="form-text text-muted mb-2">
            {t_controls.seo_keywords_help}
          </small>
          {locales.map(({ code, label }) => (
            <div key={`keywords-${code}`} className="mb-2">
              <label htmlFor={`seoKeywords-${code}`} className="small text-muted">{label}</label>
              <input
                type="text"
                className="form-control"
                id={`seoKeywords-${code}`}
                value={(seoData.keywords && seoData.keywords[code]) || ""}
                onChange={(e) => handleChange("keywords", code, e.target.value)}
                placeholder={`e.g., Team Name, Club Name, Sport (${label})`}
              />
            </div>
          ))}
        </div>

        {/* SEO Meta Description */}
        <div className="form-group mt-4">
          <label><strong>{t_controls.seo_meta_description}</strong></label>
          <small className="form-text text-muted mb-2">
            {t_controls.seo_meta_description_help || "Description shown in search engine results (150-160 characters recommended)"}
          </small>
          {locales.map(({ code, label }) => (
            <div key={`description-${code}`} className="mb-2">
              <label htmlFor={`seoMetaDescription-${code}`} className="small text-muted">{label}</label>
              <textarea
                className="form-control"
                id={`seoMetaDescription-${code}`}
                rows="2"
                value={(seoData.meta_description && seoData.meta_description[code]) || ""}
                onChange={(e) => handleChange("meta_description", code, e.target.value)}
                placeholder={`e.g., Official team website... (${label})`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SeoSettings;

